import { Drawer } from 'antd'
import React from 'react'
import { Field, getFormValues, reduxForm } from 'redux-form'
import FieldInput from '../../../../../../components/Fields/FieldInput'
import { required } from 'redux-form-validators'
import { Button } from 'reactstrap'
import i18n from '../../../../../../lib/i18n'
import SelectFieldAnt from '../../../../../../components/Fields/SelectFieldAnt'
import { useSelector } from 'react-redux'

function FormData({open, onClose = () => {}, initialValues, type,  handleSubmit, onSave = () => {}, reset, folders=[], subfolders=[], change}) {
  const formValues = useSelector(state => getFormValues('folder')(state))
  return (
    <Drawer
      title={i18n('pr_folder_form')}
      placement="left"
      onClose={() => {
        reset();
        onClose()
      }}
      open={open}
    >
      <form onSubmit={handleSubmit(onSave)}>
        <Field component={FieldInput} name="title" label={i18n('pr_folder_title')} validate={[required({msg: i18n('is required')})]} />
        <Field 
          component={SelectFieldAnt} 
          // disabled={initialValues.id && initialValues.branch_id} 
          name="parent_id"
          options={folders.map(_i => ({value: _i.id, title: _i.title}))} 
          label={i18n('pr_folder_parent')}
          handleChange={() => {
            change('sub_parent_id', '')
          }}
          validate={[required({msg: i18n('is required')})]} 
        />
        {type == 'subcategory' && <Field 
          component={SelectFieldAnt} 
          // disabled={initialValues.id && initialValues.branch_id} 
          name="sub_parent_id"
          options={subfolders.filter(_i => _i.parent_id == formValues?.parent_id).map(_i => ({value: _i.id, title: _i.title}))} 
          label={i18n('pr_sub_folder_parent')}
          validate={[required({msg: i18n('is required')})]} 
        />}
        <Button color="primary" style={{width: '100%', marginTop: 20}}>{i18n('Save')}</Button>
      </form>
    </Drawer>
  )
}
export default reduxForm({
  // reset() wipes syncErrors and the values do not change, so the default check never revalidates
  shouldError: () => true,
  form: 'folder',
  enableReinitialize: true
})(FormData)